<template lang="pug">
  .resource-view-wrapper
    include ResourcesCovid.pug
</template>

<script>
import _ from "underscore"

export default {
  name: 'ResourcesCovid',
  props: [
  ],
  components: {
  },
  data () {
    return {
    }
  },
  created() {
  }
}
</script>

<style lang="scss">
@import "./../../variables";

.resource-view-wrapper {
  @import "../dashboard/Dashboard";
  @import "../dashboard/DashboardIndex";
  @import "ResourcesCovid";
}

</style>



// WEBPACK FOOTER //
// src/components/resources_covid/ResourcesCovid.vue